import React, { useEffect, useState, useMemo, useRef } from "react";
import { FaPlus, FaTrash, FaTrashAlt } from "react-icons/fa";
import { TableContainer } from "@mui/material";
import { Icon } from "@iconify/react";
import { toPlainFields } from "Components/support/Allfields/fieldconverter";
import { DesignServices } from "@mui/icons-material";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { DiamondPopUpFields } from "Components/support/Allfields/diamondFields";
import Select from "react-select";
import { generateDropDownList } from "utils/helpers";

const selectStyle = {
  control: (base) => ({
    ...base,
    minHeight: "35px",
    height: "30px",
  }),
  placeholder: (base) => ({
    ...base,
    color: "#aaa",
    fontStyle: "italic",
    display: "none",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "blue"
      : state.isFocused
      ? "lightblue"
      : "white",
    color: state.isSelected ? "white" : "black",
    padding: "6px",
    fontSize: "12px",
    whiteSpace: "normal", // Allows text to wrap instead of truncating
    textOverflow: "unset", // Removes ellipsis
    overflow: "visible", // Ensures full visibility of text
  }),
  singleValue: (base) => ({
    ...base,
    fontSize: "12px",
    padding: "2px 2px 2px 0px", // Decreases padding inside the input box
    whiteSpace: "normal", // Allows full text to display
    textOverflow: "unset", // Removes ellipsis
    overflow: "visible", // Ensures full visibility of text
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "8px",
    marginTop: "5px",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "4px",
    svg: {
      width: "12px",
      height: "12px",
    },
  }),
  indicatorsContainer: (base) => ({
    ...base,
    padding: "0px",
  }),
};

const defaultValue = {
  DiamondShape: "",
  DiamondClarity: "",
  DiamondColour: "",
  DiamondSleve: "",
  DiamondSize: "",
  DiamondWeight: 0,
  DiamondRate: 0,
  DiamondPieces: "",
  DiamondAmount: 0,
  DiamondCut: "",
  DiamondSettingType: "",
  DiamondCertificate: "",
  DiamondDescription: "",
};
const SingleDiamondPopUpNew = ({
  diamondEdit,
  diamondEditValues,
  addDiamond,
  itemlist,
  index,
  onClose,
  onSave,
  stonemaster,
  dropdownListData,
  Diamonds,
  setFormValue
}) => {
  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    formState: { errors },
    trigger
  } = useForm({
    defaultValues: {
      diamonds: Diamonds?.length > 0 ? Diamonds : [defaultValue],
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "diamonds", // This matches the key in `defaultValues`
  });

  const diamondWeights = watch('diamonds', []).map(diamond => diamond.DiamondWeight) || [];
  const diamondRates = watch('diamonds', []).map(diamond => diamond.DiamondRate) || [];
  const diamondAmounts = watch('diamonds', []).map(diamond => diamond.DiamondAmount) || [];

  const localfields = useMemo(() => toPlainFields(DiamondPopUpFields), []);

  const [itemfields, setItemfields] = useState(() => {
    // Initialize fields with defaults
    const updatedFields = localfields?.map((localField) => ({
      ...localField,
      value: "", // Initialize value as empty string
      label: localField.label || "Default Label",
      placeholder: localField.placeholder || "Enter value",
      priority: localField.priority || 1,
      visibility: localField.visibility,
      place: localField.place,
    }));
    return updatedFields;
  });


  





  const handleSave = () => {
    handleSubmit(onSubmit)();
  };

  const onSubmit = (data) => {
    addDiamond(data);
  };

  
  

  useEffect(() => {
    // Loop through all the rows to calculate DiamondAmount
    diamondWeights.forEach((weight, index) => {
      const rate = diamondRates[index];
      if (weight && rate) {
        // Calculate the DiamondAmount
        const amount = parseFloat(weight) * parseFloat(rate);
        // Only update if the calculated amount is different from the existing one
        const existingAmount = watch(`diamonds.${index}.DiamondAmount`);
        if (existingAmount !== amount.toFixed(2)) {
          setValue(`diamonds.${index}.DiamondAmount`, amount.toFixed(2));
        }
      }
    });
    
    

  }, [diamondWeights, diamondRates, setValue, watch]);


 const total = useMemo(()=>{

    const totalAmount = diamondAmounts?.reduce((curr,acc)=>{
      return +curr + +acc
    },0)
    const totalRate = diamondRates?.reduce((curr,acc)=>{
      return  +curr + +acc
    },0)
    const totalWeight = diamondWeights?.reduce((curr,acc)=>{
      return +curr + +acc},0)

      return {totalAmount:totalAmount?.toFixed(3),totalRate:totalRate?.toFixed(3),totalWeight:totalWeight?.toFixed(3)}


  },[
    diamondWeights, diamondRates,diamondAmounts
  ])
   
  const firstFieldRef = useRef(null);


  useEffect(() => {
    // Focus on the first field when the popup opens
    if (firstFieldRef.current) {
      firstFieldRef.current.focus();
    }
  }, []);


  const trRef = useRef([]);
 
  const handleEnterKey = (e, stoneIndex, fieldIndex) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent the default Enter key behavior
  
      // Get total fields and rows
      const totalFields = itemfields.length;
      const totalRows = fields.length;
  
      if (fieldIndex < totalFields - 1) {
        // Move to the next field in the same row
        const nextFieldName = `diamonds.${stoneIndex}.${itemfields[fieldIndex + 1].key}`;
        const nextField = document.querySelector(`[name="${nextFieldName}"]`);
        if (nextField) {
          nextField.focus();
        }
      } else if (stoneIndex < totalRows - 1) {
        // Move to the first field of the next row
        const nextRowFirstFieldName = `diamonds.${stoneIndex + 1}.${itemfields[0].key}`;
        const nextRowFirstField = document.querySelector(
          `[name="${nextRowFirstFieldName}"]`
        );
        if (nextRowFirstField) {
          nextRowFirstField.focus();
        }
      } else if (
        stoneIndex === totalRows - 1 &&
        fieldIndex === totalFields - 1
      ) {
        // Last field of the last row: Add a new row and focus on its first field
        append(defaultValue);
        setTimeout(() => {
          const newRowFirstFieldName = `diamonds.${stoneIndex + 1}.${itemfields[0].key}`;
          const newRowFirstField = document.querySelector(
            `[name="${newRowFirstFieldName}"]`
          );
          if (newRowFirstField) {
            newRowFirstField.focus();
          }
        }, 0); // Slight delay to ensure the DOM is updated
      }
    }
  };
  
  console.log(itemfields)
  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header" style={{display:'flex',justifyContent:"space-between",padding:"0px 10px"}}>
          <p style={{ fontSize: "14px", fontWeight: "bold" }}>
            Add Diamond Details
          </p>
          <Icon
            style={{
              cursor: "pointer",
              fontSize: "26px",
              color: "#627282",
            }}
            icon="carbon:close-filled"
            onClick={onClose} // Close the modal
          />
        </div>

        <div
     style={{
      flex: "1", // Allow the table container to grow and fill space
      overflowY: "auto", // Enable vertical scrolling only
      overflowX: "hidden", // Prevent horizontal scrolling
      maxHeight: "60vh", 
    }}
    >
        <table className="diamond-table">
          <thead>
            <tr>
              {itemfields
                ?.filter(
                  (field) =>
                    field?.place === "top" &&
                    field?.visibility !== "Hidden" &&
                    field?.IsVisible
                )
                ?.sort((a, b) => a.priority - b.priority)
                ?.map((field) => (
                  <th key={field.key}
                  
                  >{field.label || field.key}</th>
                ))}
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {fields?.map((stone, stoneIndex) => (
              <tr key={stone?.id}>
                {itemfields
                  ?.filter(
                    (field) =>
                      field?.place === "top" &&
                      field?.visibility !== "Hidden" &&
                      field?.IsVisible
                  )
                  ?.sort((a, b) => a.priority - b.priority)
                  ?.map((field, fieldIndex) => {
                    return (
                      <td
                      onKeyDown={(e) =>
                        handleEnterKey(e, stoneIndex, fieldIndex)
                      }
                        key={field.key}
                        ref={(el) => (trRef.current[stoneIndex] = el)}
                        style={{
                          width:
                            field.type === "dropdown" ||
                            field.type === "searchDropdown"
                              ? "300px" // Set a larger width for dropdowns
                              : "auto", // Default width for other fields
                        }}
                       
                      >
                        {field.type === "dropdown" ||
                        field.type === "searchDropdown" ? (
                          <select
                            name={`diamonds.${stoneIndex}.${field.key}`}
                            {...register(`diamonds.${stoneIndex}.${field.key}`)}
                            disabled={field.visibility === "ReadOnly"}
                            // onFocus={() =>
                            //   handleFocusOnLastField(stoneIndex, fieldIndex)
                            // }
                            // onKeyDown={(e) =>
                            //   handleEnterKey(e, stoneIndex, fieldIndex)
                            // }
                            ref={(e) => {
                              register(`diamonds.${stoneIndex}.${field.key}`).ref(e);
                              if (stoneIndex === 0 && fieldIndex === 0) firstFieldRef.current = e;
                            }}

                            style={{
                              background:
                                field.visibility !== "ReadOnly"
                                  ? "white"
                                  : "#f0f0f0",
                              width: "100%", // Optional: Adjust as needed for styling
                              border:"1px solid #ddd"
                            }}
                          >
                            {generateDropDownList(field, dropdownListData)?.map(
                              (item) => (
                                <option key={item?.label} value={item?.value}>
                                  {item?.label}
                                </option>
                              )
                            )}
                          </select>
                        ) : field.type === "number" || field.type === "text" ? (
                          <div style={{ position: "relative" }}>
                            <input
                              type={field.type}
                              name={`diamonds.${stoneIndex}.${field.key}`}
                              ref={stoneIndex === 0 && fieldIndex === 0 ? firstFieldRef : null} // Apply ref to the first field

                              disabled={field.visibility === "ReadOnly"}
                              {...register(
                                `diamonds.${stoneIndex}.${field.key}`,
                                {}
                              )}
                           
                              style={{
                                background: `${
                                  field.visibility !== "ReadOnly"
                                    ? "white"
                                    : "#f0f0f0"
                                }`,
                                width: "100%",
                                border:"1px solid #ddd"
                              }}
                            />
                          </div>
                        ) : (
                          ""
                        )}
                      </td>
                    );
                  })}
                <td
                  onKeyDown={(e) =>
                    handleEnterKey(e, stoneIndex, fieldIndex)
                  } 
                  ref={(el) => (trRef.current[stoneIndex] = el)}
                  align="center"
                >
                  <FaTrashAlt
                    size={22}
                    style={{ cursor: "pointer",color:"#A9A9A9" }}
                    onClick={() => remove(stoneIndex)}
                  />
                </td>
              </tr>
            ))}
          </tbody>

          <tfoot>
            <tr>
              {itemfields.map((field) => (
                <td key={field.key}>
                  {field.key === "DiamondWeight" ? 
                      total?.totalWeight
                  : field.key === "DiamondAmount" ?  total?.totalAmount: ""
                  }
                </td>
              ))}
              <td>Total</td>
            </tr>
          </tfoot>
        </table>
        </div>
        <div  style={{display:"flex",justifyContent:'center',margin:"20px 0px"}}>
          <button onClick={handleSave} className="save-button" type="button">
            Save
          </button>
          {/* <button
            onClick={() => {
              append(defaultValue);
            }}
            className="save-button"
            type="button"
          >
            Add
          </button> */}
          <button onClick={onClose} className="cancel-button" type="button">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default SingleDiamondPopUpNew;
